import { timelineSteps } from "@/mocks/verify";

const toneBar: Record<string, string> = {
  neutral: "bg-secondary-300",
  ferment: "bg-accent-400",
  confirm: "bg-primary-400",
  clarify: "bg-secondary-500",
  reversal: "bg-accent-500",
};

const toneIcon: Record<string, string> = {
  neutral: "ri-chat-smile-3-line",
  ferment: "ri-fire-line",
  confirm: "ri-search-line",
  clarify: "ri-mic-line",
  reversal: "ri-loop-left-line",
};

export default function Timeline() {
  return (
    <section id="reversal" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-600">
              Reversal Timeline
            </p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-[2rem]">
              反转追踪：一条传闻如何被证伪
            </h2>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
              多数“实锤”演变成“反转”，走的都是同一条路径。理解这条时间线，你也能在下次刷到时提前保持警惕。
            </p>
          </div>
          <div className="inline-flex items-center gap-2 self-start rounded-full border border-accent-200 bg-accent-50 px-4 py-2 text-sm font-semibold text-accent-700 md:self-auto">
            <i className="ri-alarm-warning-line text-base" aria-hidden="true"></i>
            传播越快，越要慢一步下结论
          </div>
        </div>

        <ol className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-5">
          {timelineSteps.map((step, i) => (
            <li
              key={step.stage}
              className="relative flex flex-col rounded-xl border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300"
            >
              <div className="flex items-center justify-between">
                <span className={`flex h-10 w-10 items-center justify-center rounded-lg ${toneBar[step.tone]}`}>
                  <i className={`${toneIcon[step.tone]} text-lg text-background-50`} aria-hidden="true"></i>
                </span>
                <span className="font-heading text-4xl font-black text-background-300">{String(i + 1).padStart(2, "0")}</span>
              </div>
              <p className="mt-4 text-[11px] font-semibold uppercase tracking-widest text-foreground-400">{step.stage}</p>
              <h3 className="mt-1 font-heading text-lg font-bold text-foreground-950">{step.title}</h3>
              <p className="mt-2 text-[13px] leading-relaxed text-foreground-600">{step.desc}</p>
            </li>
          ))}
        </ol>

        <div className="mt-6 flex flex-col gap-4 rounded-xl border border-background-200 bg-primary-50/50 px-6 py-6 md:flex-row md:items-center md:justify-between">
          <div className="flex items-start gap-3">
            <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary-600 text-background-50">
              <i className="ri-lightbulb-flash-line text-lg" aria-hidden="true"></i>
            </span>
            <p className="text-sm leading-relaxed text-foreground-700">
              一句话提醒：看到只有截图、没有出处的“大瓜”，先默认当作<strong className="font-semibold text-foreground-950">待核验</strong>，
              等完整证据链出现再下判断。
            </p>
          </div>
          <a
            href="#guide"
            className="inline-flex shrink-0 items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-primary-300 bg-background-50 px-5 py-2.5 text-sm font-semibold text-primary-700 transition-colors hover:bg-primary-600 hover:text-background-50"
          >
            学习分辨四步法
            <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </section>
  );
}